export enum CustomExceptionTypes {
  LOGIN_ERROR,
  NEED_LOGIN,
  UNKNOWN_ERROR,
  CANCELED,
  USER_INPUT_ERROR,
  FETCH_ERROR,
  SYS_ERROR,
  UNPROCESSABLE_ENTITY,
}
